import {
  ClickAndCollectSortBy,
  ClickAndCollectStore,
  ScheduleEntries,
  StoreInformation,
  StoreInformationWithPagePathAndImage,
  StoresPagePathAndImageByStore,
} from '@as-react/common-types';

const getTodaysOpeningHours = (store: StoreInformation, currantDate: Date) => {
  let result: ScheduleEntries | undefined;

  if (store.scheduleEntries) {
    for (const day of store.scheduleEntries) {
      if (!result) {
        const myDate = new Date(day.date);
        if (myDate.getDate() === currantDate.getDate() && myDate.getMonth() === currantDate.getMonth()) {
          result = day;
          break;
        }
      }
    }
  }

  return result;
};

const isOpen = (store: StoreInformation) => {
  const currantDate = new Date();
  const time = currantDate.getHours() * 60 + currantDate.getMinutes();
  const today = getTodaysOpeningHours(store, currantDate);

  return Boolean(today && time > today.openTimeInMinutes && time < today.closeTimeInMinutes);
};

const isOpenLate = (store: StoreInformation, openLateTimeInMinutes: number) => {
  const currantDate = new Date();
  const today = getTodaysOpeningHours(store, currantDate);

  return Boolean(today && today.closeTimeInMinutes > openLateTimeInMinutes);
};

export const getMappedStoreInformation = (
  stores: Array<StoreInformation>,
  additionalStoresData: Array<StoresPagePathAndImageByStore>
) =>
  stores
    .filter(store => store.geographic.latitude && store.geographic.longitude)
    .map(store => {
      const additionalStoreData = additionalStoresData.find(item => item.code === String(store.code));

      return {
        ...store,
        relativeStorePagePath: additionalStoreData?.relativeStorePagePath || '',
        image: additionalStoreData?.image || null,
      };
    });

export const updateStoresOpenState = (stores: Array<StoreInformationWithPagePathAndImage> = [], openAfterTime = 0) => {
  return stores.map(store => {
    const sundayEntry = store.scheduleEntries?.[6];

    return {
      ...store,
      openNow: isOpen(store),
      openLate: isOpenLate(store, openAfterTime),
      openSunday: Boolean(sundayEntry && !sundayEntry.closed),
    };
  });
};

export const sortStoresBy = (
  stores: Array<ClickAndCollectStore>,
  sortBy: ClickAndCollectSortBy,
  selectedStoreId?: number
) => {
  const sortedStores = stores.sort((storeA: ClickAndCollectStore, storeB: ClickAndCollectStore) => {
    if (sortBy === 'distance') {
      return storeA.distance - storeB.distance;
    } else if (sortBy === 'storeName') {
      return storeA.storeName.localeCompare(storeB.storeName);
    }

    return -1;
  });

  return selectedStoreId ? moveItemToFront(sortedStores, selectedStoreId) : sortedStores;
};

const moveItemToFront = (stores: Array<ClickAndCollectStore>, storeId: number) => {
  const index = stores.findIndex(item => item.storeId === storeId);
  if (index > -1) {
    const [item] = stores.splice(index, 1);
    stores.unshift(item!);
  }
  return stores;
};
